// src/lib/demoData.js
// デモモード用ダミーデータ（Supabaseの代替）

export const DEMO_USER = {
  id: 'demo-user-001',
  email: 'demo@totono.app',
};

export const DEMO_PROFILE = {
  id: 'demo-user-001',
  name: '田中 太郎',
  invoice_prefix: 'INV',
  bank_info: '〇〇銀行 渋谷支店\n普通口座 1234567\n口座名義：タナカ タロウ',
  qualified_invoice_no: '',
  signature: '屋号：田中デザイン事務所\n氏名：田中 太郎\n住所：東京都渋谷区〇〇1-2-3\nTEL：090-0000-0000',
  hanko: '田中',
  plan: 'free',
};

export const DEMO_CLIENTS = [
  { id: 'demo-client-001', user_id: 'demo-user-001', name: '株式会社サンプル' },
  { id: 'demo-client-002', user_id: 'demo-user-001', name: 'テスト合同会社' },
];

const today = new Date();
const fmt = (d) => d.toISOString().split('T')[0];
const daysAgo = (n) => fmt(new Date(today.getFullYear(), today.getMonth(), today.getDate() - n));
const thisMonth = (d) => fmt(new Date(today.getFullYear(), today.getMonth(), d));

export const DEMO_PROJECTS = [
  {
    id: 'demo-proj-001',
    user_id: 'demo-user-001',
    client_id: 'demo-client-001',
    title: 'コーポレートサイトリニューアル',
    status: '進行中',
    work_type: 'project',
    amount: 500000,
    hourly_rate: null,
    hours_worked: null,
    work_days: null,
    start_date: daysAgo(30),
    due_date: daysAgo(-15),
    tag: 'Web',
    memo: 'トップ・会社概要・採用ページの制作',
    payment_method: '銀行振込',
    clients: { id: 'demo-client-001', name: '株式会社サンプル' },
    project_work_dates: [],
  },
  {
    id: 'demo-proj-002',
    user_id: 'demo-user-001',
    client_id: 'demo-client-002',
    title: 'LP制作（キャンペーン用）',
    status: '完了',
    work_type: 'daily',
    amount: null,
    hourly_rate: 40000,
    hours_worked: null,
    work_days: 5,
    start_date: daysAgo(20),
    due_date: daysAgo(5),
    tag: 'LP',
    memo: '',
    payment_method: '銀行振込',
    clients: { id: 'demo-client-002', name: 'テスト合同会社' },
    project_work_dates: [
      { date: daysAgo(18) },
      { date: daysAgo(16) },
      { date: daysAgo(14) },
      { date: daysAgo(11) },
      { date: daysAgo(9) },
    ],
  },
  {
    id: 'demo-proj-003',
    user_id: 'demo-user-001',
    client_id: 'demo-client-001',
    title: 'システム保守・運用サポート',
    status: '進行中',
    work_type: 'monthly',
    amount: 150000,
    hourly_rate: null,
    hours_worked: null,
    work_days: null,
    start_date: fmt(new Date(today.getFullYear(), today.getMonth(), 1)),
    due_date: fmt(new Date(today.getFullYear(), today.getMonth() + 1, 0)),
    tag: '保守',
    memo: '月次レポート・障害対応込み',
    payment_method: '銀行振込',
    clients: { id: 'demo-client-001', name: '株式会社サンプル' },
    project_work_dates: [],
  },
  {
    id: 'demo-proj-004',
    user_id: 'demo-user-001',
    client_id: 'demo-client-002',
    title: 'バナー・SNS素材制作',
    status: '商談中',
    work_type: 'hourly',
    amount: null,
    hourly_rate: 3500,
    hours_worked: 6,
    work_days: 3,
    start_date: thisMonth(15),
    due_date: thisMonth(25),
    tag: 'デザイン',
    memo: '',
    payment_method: '先払い',
    clients: { id: 'demo-client-002', name: 'テスト合同会社' },
    project_work_dates: [
      { date: thisMonth(15) },
      { date: thisMonth(18) },
      { date: thisMonth(20) },
    ],
  },
];

export const DEMO_WORK_DATES = [
  // LP制作（daily）
  { id: 'wd-001', project_id: 'demo-proj-002', user_id: 'demo-user-001', date: daysAgo(18), work_hours: 8, memo: '' },
  { id: 'wd-002', project_id: 'demo-proj-002', user_id: 'demo-user-001', date: daysAgo(16), work_hours: 8, memo: '' },
  { id: 'wd-003', project_id: 'demo-proj-002', user_id: 'demo-user-001', date: daysAgo(14), work_hours: 7, memo: 'デザインレビュー対応' },
  { id: 'wd-004', project_id: 'demo-proj-002', user_id: 'demo-user-001', date: daysAgo(11), work_hours: 8, memo: '' },
  { id: 'wd-005', project_id: 'demo-proj-002', user_id: 'demo-user-001', date: daysAgo(9),  work_hours: 5, memo: '修正・納品' },
  // バナー制作（hourly）
  { id: 'wd-006', project_id: 'demo-proj-004', user_id: 'demo-user-001', date: thisMonth(15), work_hours: 6, memo: '' },
  { id: 'wd-007', project_id: 'demo-proj-004', user_id: 'demo-user-001', date: thisMonth(18), work_hours: 6, memo: '' },
  { id: 'wd-008', project_id: 'demo-proj-004', user_id: 'demo-user-001', date: thisMonth(20), work_hours: 6, memo: 'ラフ確認' },
];

export const DEMO_INVOICES = [
  {
    id: 'demo-inv-001',
    user_id: 'demo-user-001',
    project_id: 'demo-proj-002',
    amount: 200000,
    tax_rate: 10,
    payment_method: '銀行振込',
    issued_at: daysAgo(7),
    to_company: 'テスト合同会社',
    to_contact: '山田 様',
    tax_included: false,
    linked_projects: ['demo-proj-002'],
    linked_expenses: [],
  },
];

export const DEMO_EXPENSES = [
  {
    id: 'demo-exp-001',
    user_id: 'demo-user-001',
    project_id: 'demo-proj-001',
    amount: 3500,
    category: '交通費',
    memo: 'クライアント訪問（電車）',
    date: daysAgo(10),
    receipt_url: null,
  },
  {
    id: 'demo-exp-002',
    user_id: 'demo-user-001',
    project_id: null,
    amount: 12800,
    category: 'ソフトウェア',
    memo: 'Adobe CC 月額',
    date: thisMonth(1),
    receipt_url: null,
  },
  {
    id: 'demo-exp-003',
    user_id: 'demo-user-001',
    project_id: 'demo-proj-002',
    amount: 5400,
    category: '会議費',
    memo: 'キックオフMTG（喫茶）',
    date: daysAgo(22),
    receipt_url: null,
  },
];
